
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { WorkStationsForCategoryResponse, WorkStationsListResponseModel } from '@gtpl/shared-models/production-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { WorkStationCategoryRequest } from './dto/work-station-category.request';
import { WorkstationsService } from './workstations.service';
import { WorkstationDTO } from './dto/workstation.dto';
import { WorkstationResponseModel, AllWorkstationResponseModel,CommonResponse } from '@gtpl/shared-models/production-management';
import { WorkstationRequest } from './dto/workstation.request';
import { UnitRequest } from '../operations-track/dto/unit.id.request';

@ApiTags('Workstation')
@Controller('workstations')
export class WorkstationsController {
    constructor(private service: WorkstationsService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,
    ) {

    }

    /**
   * Creates workstation 
   * @param workstationDTO 
   * @param isUpdate 
   * @param request 
   * @returns 
   */
    @Post('/createWorkstation')
    async createWorkstation(@Body() workstationDTO: WorkstationDTO, isUpdate: boolean = false, @Req() request: Request): Promise<WorkstationResponseModel> {
        try {
            return await this.service.createWorkstation(workstationDTO, false, request);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(WorkstationResponseModel, error)
        }
    }
    /**
     * 
     * @param workstationDTO 
     * @param request 
     * @returns 
     */
    @Post('/updateWorkstation')
    async updateWorkstation(@Body() workstationDTO: WorkstationDTO, @Req() request: Request): Promise<WorkstationResponseModel> {
        try {
            return await this.service.createWorkstation(workstationDTO, true, request);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(WorkstationResponseModel, error)
        }
    }
    /**
     * 
     * @param request 
     * @returns 
     */
    @Post('/getAllWorkstation')
    async getAllWorkstation(@Body() req: UnitRequest): Promise<AllWorkstationResponseModel> {
        try {
            return await this.service.getAllWorkstation(req);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(AllWorkstationResponseModel, error)
        }
    }
    @Post('/activateorDeactivateWorkstation')
    async activateorDeactivateWorkstation(@Body() workstationCategoryReq: WorkstationRequest): Promise<WorkstationResponseModel> {
        try {
            return await this.service.activateorDeactivateWorkstation(workstationCategoryReq);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(WorkstationResponseModel, err);
        }
    }

    @Post('/getWorkStationsForCategory')
    async getWorkStationsForCategory(@Body() category: WorkStationCategoryRequest): Promise<WorkStationsForCategoryResponse> {
        try {
            return await this.service.getWorkStationsForCategory(category);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(WorkStationsForCategoryResponse, error)
        }
    }
    @Post('/getAllWorkStationsForCategory')
    async getAllWorkStationsForCategory(@Body() category: WorkStationCategoryRequest): Promise<WorkStationsListResponseModel> {
        try {
            return await this.service.getAllWorkStationsForCategory(category);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(WorkStationsListResponseModel, error)
        }
    }

    @Post('/getWorkStationsById')
    async getWorkStationsById(@Body() inputReq: WorkstationRequest): Promise<WorkstationResponseModel> {
        try {
            return await this.service.getWorkStationsById(inputReq);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(WorkstationResponseModel, error)
        }
    }

    @Post('/getCapacityForPlantAndWorkstation')
    async getCapacityForPlantAndWorkstation(@Body() inputReq: WorkstationRequest): Promise<CommonResponse> {
        try {
            return await this.service.getCapacityForPlantAndWorkstation(inputReq);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(CommonResponse, error)
        }
    }
}
